<template>
  <div>
    <div
      class="HeroContainer"
      v-bind:style="{
        'font-size': fontSize,
        'margin-left': marginLeft,
        width: '100%',
        'margin-top': marginTop,
      }"
    >
      <div class="HeroContent">
        <div
          class="HeroText"
          v-bind:style="{
            width: width,
            marginRight: heroMargin,
          }"
        >
          <p
            class="font-weight-bold"
            v-bind:style="{
              fontSize: fontSizeTitleHero,
            }"
          >
            Sukseskan Proyek Tanpa
            <span class="red--text">Khawatir Pembiayaan!</span>
          </p>
          <p
            class="font-weight-normal"
            v-bind:style="{
              'font-size': fontSizeSub,
              'font-family': 'Inter',
              'font-weight': 600,
              width: widthDesc,
              'line-height': lineHeight,
            }"
          >
            Pinjaman fleksibel tanpa agunan bagi pemilik usaha. Bunga
            kompetitif, mulai dari 10% per tahun dan tenor hingga 12 bulan!
          </p>
        </div>
        <div
          class="Shape"
          v-bind:style="{
            width: widthForm,
            marginTop: shapeMargin,
            padding: paddingShape,
          }"
        >
          <p
            class="title-1"
            v-bind:style="{
              'font-family': 'Sora',
              'font-size': fontSizeForm,
            }"
          >
            Daftar Pinjaman Sekarang!
          </p>
          <p
            class="desc"
            v-bind:style="{
              'font-family': 'Inter',
              'font-size': fontSizeDescription,
            }"
          >
            Isi formulir di bawah dengan benar untuk mendapatkan pinjaman!
          </p>
          <v-form ref="form" v-model="valid">
            <div class="Name-Input">
              <p
                class="Name-Title"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                  'margin-bottom': marginName,
                }"
              >
                Nama Lengkap
              </p>
              <v-text-field
                class="input-field"
                color="#D3352C"
                v-model="form.full_name"
                :rules="reqRules"
                placeholder="Nama Anda"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                }"
              />
            </div>
            <div class="Name-Input">
              <p
                class="Name-Title"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                  'margin-bottom': marginName,
                  'margin-top': marginTopName,
                }"
              >
                Alamat Email
              </p>
              <v-text-field
                class="input-field"
                color="#D3352C"
                v-model="form.email"
                :rules="emailRules"
                placeholder="Email Anda"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                }"
              />
            </div>
            <div class="Name-Input">
              <p
                class="Name-Title"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                  'margin-bottom': marginName,
                  'margin-top': marginTopName,
                }"
              >
                No Telepon
              </p>
              <v-text-field
                class="input-field"
                color="#D3352C"
                type="number"
                v-model="form.phone_number"
                :rules="phoneRules"
                prefix="(+62)"
                placeholder="No Telepon Anda"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                }"
              />
            </div>
            <div class="Name-Input">
              <p
                class="Name-Title"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                  'margin-bottom': marginName,
                  'margin-top': marginTopName,
                }"
              >
                Nama Perusahaan
              </p>
              <v-text-field
                class="input-field"
                color="#D3352C"
                v-model="form.company"
                :rules="reqRules"
                placeholder="Nama Perusahaan"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                }"
              />
            </div>
            <div class="Name-Input">
              <p
                class="Name-Title"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                  'margin-bottom': marginName,
                  'margin-top': marginTopName,
                }"
              >
                Bidang Perusahaan
              </p>
              <v-select
                v-model="form.job_type"
                :items="jobTypeOptions"
                item-text="name"
                item-value="code"
                label="Bidang Perusahaan"
                persistent-hint
                single-line
                dense
                color="#D3352C"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                }"
              ></v-select>
              <div
                v-if="jobErr"
                class="mt-n3 red--text"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                }"
              >
                required
              </div>
            </div>
            <div class="Name-Input">
              <p
                class="Name-Title"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                  'margin-bottom': marginName,
                  'margin-top': marginTopName,
                }"
              >
                Jumlah Pinjaman
              </p>
              <vuetify-money
                class="input-field"
                color="#D3352C"
                v-model="form.amount"
                v-bind:rules="amountRules"
                v-bind:options="options"
                placeholder="Jumlah Pinjaman Anda"
                v-bind:style="{
                  'font-family': 'Inter',
                  'font-size': fontSizeDescr,
                }"
              />
            </div>
          </v-form>
          <v-btn
            @click="submit()"
            color="#D3352C"
            rounded
            block
            dark
            class="Shape-Button-Text text-none"
            ><p style="margin:0px;">Kirim Pendaftaran</p></v-btn
          >
        </div>
      </div>
    </div>
    <img src="../assets/lpse/Hero.jpg" class="Hero" />
    <div
      class="d-flex align-center justify-center mt-n1 py-4"
      style="background-color: #310A0A;"
    >
      <div>
        <img
          v-bind:style="{
            width: widthPoint,
          }"
          class="point"
          src="../assets/lpse/Pinjaman-Tersalurkan.svg"
        />
        <img
          v-bind:style="{
            width: widthPoint,
          }"
          class="point"
          src="../assets/lpse/Pinjaman-Lunas.svg"
        />
        <img
          v-bind:style="{
            width: widthPoint,
          }"
          class="point"
          src="../assets/lpse/Total-Outstanding.svg"
        />
        <img
          v-bind:style="{
            width: widthPoint,
          }"
          class="point"
          src="../assets/lpse/Total-Peminjam.svg"
        />
      </div>
    </div>
    <div class="why-container" style="background-color: #FFFFFF;">
      <div class="why-1">
        <div
          class="why-text"
          v-bind:style="{
            'font-family': 'Sora',
            fontSize: fontSizeWhy,
            width: widthBg,
            height: heightBgRedWhy,
            padding: paddingShapeWhy,
          }"
        >
          Kenapa Memilih Dompet Kilat?
        </div>
      </div>
      <div
        class="why-2"
        v-bind:style="{
          marginRight: marginWhy,
        }"
      >
        <img
          src="../assets/lpse/Contents.jpg"
          v-bind:style="{
            width: widthWhyPicture,
          }"
        />
      </div>
    </div>
    <div
      class="d-flex flex-column align-center justify-center py-12"
      style="background-color: #FFFFFF;"
    >
      <h1
        class="titleText"
        v-bind:style="{
          fontSize: fontSize,
        }"
      >
        Apa yang Harus Dilakukan?
      </h1>
      <div class="what-container">
        <div
          class="card1"
          v-bind:style="{
            width: widthCard,
            height: heightCard,
          }"
        >
          <p
            class="peminjam"
            v-bind:style="{
              fontSize: fontSizePeminjam,
              'font-family': 'Sora',
            }"
          >
            Dilakukan Oleh Peminjam
          </p>
          <div class="card-point1">
            <div
              class="circle-point"
              v-bind:style="{
                width: widthCircle,
                height: heightCircle,
              }"
            >
              <div
                class="one"
                v-bind:style="{
                  fontSize: fontSizeInside,
                }"
              >
                01
              </div>
            </div>
            <div
              class="point-1"
              v-bind:style="{
                width: widthPointHow,
              }"
            >
              <div
                class="imgCircle"
                v-bind:style="{
                  width: widthBgCircle,
                  height: widthBgCircle,
                  'min-width': minWidthBgCircle,
                }"
              >
                <img
                  class="imgIcon"
                  src="../assets/pengajuan/Web.svg"
                  v-bind:style="{
                    width: widthIcon,
                  }"
                  alt=""
                />
              </div>
              <div
                class="text-point"
                v-bind:style="{
                  'font-family': 'Inter',
                  fontSize: fontSizeInside,
                }"
              >
                Perusahaan pemenang tender proyek pemerintah mengajukan pinjaman
                di website Dompet Kilat
              </div>
            </div>
          </div>
          <div
            class="card-point1"
            v-bind:style="{
              marginTop: marginCard,
            }"
          >
            <div
              class="circle-point"
              v-bind:style="{
                width: widthCircle,
                height: heightCircle,
              }"
            >
              <div
                class="one"
                v-bind:style="{
                  fontSize: fontSizeInside,
                }"
              >
                02
              </div>
            </div>
            <div
              class="point-1"
              v-bind:style="{
                width: widthPointHow,
              }"
            >
              <div
                class="imgCircle"
                v-bind:style="{
                  width: widthBgCircle,
                  height: widthBgCircle,
                  'min-width': minWidthBgCircle,
                }"
              >
                <img
                  class="imgIcon"
                  src="../assets/pengajuan/Upoad.svg"
                  v-bind:style="{
                    width: widthIcon,
                  }"
                  alt=""
                />
              </div>
              <div
                class="text-point"
                v-bind:style="{
                  'font-family': 'Inter',
                  fontSize: fontSizeInside,
                }"
              >
                Peminjam mengunggah dokumen Purchase Order (PO) atau Surat
                Perintah Kerja (SPK)
              </div>
            </div>
          </div>
          <img
            src="../assets/pengajuan/Arrow.svg"
            alt=""
            class="arrow"
            v-bind:style="{
              marginLeft: marginArrow,
              marginRight: marginArrowRight,
              marginTop: marginTopArrow,
            }"
          />
          <div
            class="card-point1"
            v-bind:style="{
              marginTop: marginCard07,
            }"
          >
            <div
              class="circle-point"
              v-bind:style="{
                width: widthCircle,
                height: heightCircle,
              }"
            >
              <div
                class="one"
                v-bind:style="{
                  fontSize: fontSizeInside,
                }"
              >
                07
              </div>
            </div>
            <div
              class="point-1"
              v-bind:style="{
                width: widthPointHow,
              }"
            >
              <div
                class="imgCircle"
                v-bind:style="{
                  width: widthBgCircle,
                  height: widthBgCircle,

                  'min-width': minWidthBgCircle,
                }"
              >
                <img
                  src="../assets/pengajuan/Money.svg"
                  v-bind:style="{
                    width: widthIcon,
                  }"
                  alt=""
                  class="imgIcon"
                />
              </div>
              <div
                class="text-point"
                v-bind:style="{
                  'font-family': 'Inter',
                  fontSize: fontSizeInside,
                }"
              >
                Peminjam melunasi pinjaman dan Dompet Kilat membagikan
                keuntungan kepada para pendana.
              </div>
            </div>
          </div>
        </div>
        <div
          class="card2"
          v-bind:style="{
            width: widthCard,
            height: heightCard,
          }"
        >
          <p
            class="dompetKilat"
            v-bind:style="{
              fontSize: fontSizePeminjam,
              'font-family': 'Sora',
            }"
          >
            Dilakukan Oleh Dompet Kilat
          </p>
          <div
            class="card-point1"
            v-bind:style="{
              marginTop: marginCard02,
            }"
          >
            <div
              class="circle-point1"
              v-bind:style="{
                width: widthCircle,
                height: heightCircle,
              }"
            >
              <div
                class="two"
                v-bind:style="{
                  fontSize: fontSizeInside,
                }"
              >
                03
              </div>
            </div>
            <div
              class="point-1"
              v-bind:style="{
                width: widthPointHow,
              }"
            >
              <div
                class="imgCircle"
                v-bind:style="{
                  width: widthBgCircle,
                  height: widthBgCircle,
                  'min-width': minWidthBgCircle,
                }"
              >
                <img
                  src="../assets/pengajuan/Checklist.svg"
                  v-bind:style="{
                    width: widthIcon,
                  }"
                  alt=""
                  class="imgIcon"
                />
              </div>
              <div
                class="text-point"
                v-bind:style="{
                  'font-family': 'Inter',
                  fontSize: fontSizeInside,
                }"
              >
                Dompet Kilat menganalisa seluruh data peminjam dan memberikan
                skor kredit
              </div>
            </div>
          </div>
          <div
            class="card-point1"
            v-bind:style="{
              marginTop: marginCard,
            }"
          >
            <div
              class="circle-point1"
              v-bind:style="{
                width: widthCircle,
                height: heightCircle,
              }"
            >
              <div
                class="two"
                v-bind:style="{
                  fontSize: fontSizeInside,
                }"
              >
                04
              </div>
            </div>
            <div
              class="point-1"
              v-bind:style="{
                width: widthPointHow,
              }"
            >
              <div
                class="imgCircle"
                v-bind:style="{
                  width: widthBgCircle,
                  height: widthBgCircle,
                  'min-width': minWidthBgCircle,
                }"
              >
                <img
                  src="../assets/pengajuan/Computer.svg"
                  v-bind:style="{
                    width: widthIcon,
                  }"
                  class="imgIcon"
                  alt=""
                />
              </div>
              <div
                class="text-point"
                v-bind:style="{
                  'font-family': 'Inter',
                  fontSize: fontSizeInside,
                }"
              >
                Pinjaman diterbitkan melalui Marketplace Dompet Kilat untuk
                ditawarkan pada Pendana
              </div>
            </div>
          </div>
          <div
            class="card-point1"
            v-bind:style="{
              marginTop: marginCard,
            }"
          >
            <div
              class="circle-point1"
              v-bind:style="{
                width: widthCircle,
                height: heightCircle,
              }"
            >
              <div
                class="two"
                v-bind:style="{
                  fontSize: fontSizeInside,
                }"
              >
                05
              </div>
            </div>
            <div
              class="point-1"
              v-bind:style="{
                width: widthPointHow,
              }"
            >
              <div
                class="imgCircle"
                v-bind:style="{
                  width: widthBgCircle,
                  height: widthBgCircle,
                  'min-width': minWidthBgCircle,
                }"
              >
                <img
                  src="../assets/pengajuan/Chart_red.svg"
                  v-bind:style="{
                    width: widthIcon,
                  }"
                  alt=""
                  class="imgIcon"
                />
              </div>
              <div
                class="text-point"
                v-bind:style="{
                  'font-family': 'Inter',
                  fontSize: fontSizeInside,
                }"
              >
                Pendana menganalisa prospek keuntungan sebelum melakukan
                pendanaan.
              </div>
            </div>
          </div>
          <div
            class="card-point1"
            v-bind:style="{
              marginTop: marginCard,
            }"
          >
            <div
              class="circle-point1"
              v-bind:style="{
                width: widthCircle,
                height: heightCircle,
              }"
            >
              <div
                class="two"
                v-bind:style="{
                  fontSize: fontSizeInside,
                }"
              >
                06
              </div>
            </div>
            <div
              class="point-1"
              v-bind:style="{
                width: widthPointHow,
              }"
            >
              <div
                class="imgCircle"
                v-bind:style="{
                  width: widthBgCircle,
                  height: widthBgCircle,
                  'min-width': minWidthBgCircle,
                }"
              >
                <img
                  src="../assets/pengajuan/Money-Bag.svg"
                  v-bind:style="{
                    width: widthIcon,
                  }"
                  alt=""
                  class="imgIcon"
                />
              </div>
              <div
                class="text-point"
                v-bind:style="{
                  'font-family': 'Inter',
                  fontSize: fontSizeInside,
                }"
              >
                Pencairan pinjaman kepada peminjam untuk menyelesaikan proyek
              </div>
            </div>
          </div>
          <img
            src="../assets/pengajuan/Arrow2.svg"
            alt=""
            class="arrow"
            v-bind:style="{
              marginLeft: marginArrowRight,
              marginRight: marginArrow,
              marginTop: marginTopArrow,
            }"
          />
        </div>
      </div>
    </div>
    <v-row
      class="phoneContainer"
      v-bind:style="{
        height: heightBgRed,
        flexGrow: 0,
        marginTop: marginPhone,
        backgroundColor: '#d3352c',
      }"
      justify="center"
    >
      <div
        class="contentPhone fill-height text-wrap"
        v-bind:style="{
          marginLeft: '50px',
          marginRight: '50px',
          marginTop: '40px',
          fontSize: fontSizePhone,
          maxWidth: '750px',
        }"
      >
        <span class="font-weight-bold"> Modal Kilat</span> adalah produk Dompet
        Kilat yang menyediakan pinjaman untuk memenuhi kebutuhan modal kerja
        seperti invoice financing dan working capital loan.
        <div>
          <v-btn
            color="#222222"
            class="white--text text-none px-12 py-7 mt-3"
            elevation="0"
            @click="scrollToTop()"
            v-bind:style="{
              width: widthBtn,
              height: heightBtn,
            }"
          >
            <div
              class="contentSandboxButton"
              :style="{
                fontSize: fontSizeBtn,
              }"
            >
              Ayo Ajukan Sekarang!
            </div>
          </v-btn>
        </div>
      </div>
      <v-img
        style="margin-top: -95px; margin-right: 25px;"
        contain
        :src="require(`../assets/lpse/phone.webp`)"
        v-bind:style="{
          maxWidth: widthPhone,
        }"
      ></v-img>
    </v-row>
    <!-- <div id="app">
      <a
        href="https://api.whatsapp.com/send?phone=628777664888&text="
        class="float"
        target="_blank"
      >
        <img
          src="../assets/lpse/Whatsapp.svg"
          class="my-float"
          alt=""
          v-bind:style="{
            width: waWidth,
          }"
        />
      </a>
    </div> -->
    <popup-success :dialog="successPopup" :closeDialog="closeSuccessDialog" />
    <popup-error
      :dialog="errorPopup"
      :errorMessage="popupMsg"
      :closeDialog="closeErrDialog"
    />
  </div>
</template>

<script>
import PopupSuccess from "../components/Popup/PopupSuccess.vue";
import PopupError from "../components/Popup/PopupError.vue";
import "../plugins/vuetify-money.js";

export default {
  components: {
    PopupSuccess,
    PopupError,
  },

  data() {
    return {
      options: {
        locale: "id-ID",
        prefix: "Rp",
        suffix: "",
        length: 11,
        precision: 0,
      },
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 10}px`,
      width: `${window.innerWidth / 4}px`,
      widthNow: window.innerWidth,
      fontSize: `40px`,
      fontSizeBtn: "25px",
      fontSizeSub: `${window.innerWidth / 100}px`,
      marginTopText: `${window.innerWidth / 8}px`,
      marginTopDesc: `${window.innerWidth / 6}px`,
      descWidth: `${window.innerWidth / 2}px`,
      waWidth: `${window.innerWidth / 6}px`,
      textWidth: `${window.innerWidth / 4}px`,
      fontSizeDesc: `16px`,
      valid: true,
      form: {
        full_name: "",
        email: "",
        phone_number: "",
        amount: 0,
        gender: "L",
        company: "",
        job_type: 0,
        flag: "",
        message: "",
      },
      genderErr: false,
      jobErr: false,
      genderOptions: [
        {
          name: "Laki-laki",
          value: "L",
        },
        {
          name: "Wanita",
          value: "P",
        },
      ],
      jobTypeOptions: [],
      successPopup: false,
      errorPopup: false,
      popupMsg: "sample",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone Number is required",
        (v) => /^[8]\d*$/.test(v) || "Phone Number must be start with number 8",
        (v) =>
          (v.length > 8 && v.length < 14) ||
          "Phone number must be more than 9 and less than 13 characters",
      ],
      amountRules: [
        (v) => !!v || "Loan amount is required",
        (v) =>
          (v.replace(/\D/g, "") <= 2000000000 &&
            v.replace(/\D/g, "") >= 50000000) ||
          "Loan amount must be at 50 Juta - 2 Miliar",
      ],
      reqRules: [(v) => !!v || "required"],
    };
  },
  mounted() {
    this.onResize();
    this.getJobType();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTop = `${window.innerWidth / 10}px`;
      this.marginCard = `${window.innerWidth / 80}px`;
      this.marginArrow = `${window.innerWidth / 5}px`;
      this.marginArrowRight = `${window.innerWidth / -15}px`;
      this.marginTopArrow = `${window.innerWidth / 70}px`;
      this.marginCard02 = `${window.innerWidth / 6}px`;
      this.marginCard07 = `${window.innerWidth / 3.35}px`;
      this.marginCard05 = `${window.innerWidth / 9}px`;
      this.width = `${window.innerWidth / 2.3}px`;
      this.widthIcon = `${window.innerWidth / 60}px`;
      this.widthCard = `${window.innerWidth / 2.5}px`;
      this.widthCircle = `${window.innerWidth / 29}px`;
      this.widthBgCircle = `${window.innerWidth / 13}px`;
      this.minWidthBgCircle = `${window.innerWidth / 25}px`;
      this.heightCircle = `${window.innerWidth / 29}px`;
      this.widthCardInside = `${window.innerWidth / 5}px`;
      this.heightCard = `${window.innerWidth / 1.45}px`;
      this.widthForm = `${window.innerWidth / 3.5}px`;
      this.widthText = `${window.innerWidth / 3.7}px`;
      this.widthWhyPicture = `${window.innerWidth / 2}px`;
      this.widthWhatPicture = `${window.innerWidth / 2.6}px`;
      this.widthTextDesc = `${window.innerWidth / 5}px`;
      this.marginPhone = `${window.innerWidth / 10}px`;
      this.widthBg = `${window.innerWidth / 2.5}px`;
      this.widthFont = `${window.innerWidth / 3.5}px`;
      this.widthBtn = `${window.innerWidth / 5}px`;
      this.heightBtn = `${window.innerHeight / 25}px`;
      this.widthPoint = `${window.innerWidth / 4.5}px`;
      this.widthPointHow = `${window.innerWidth / 3.8}px`;
      this.widthPhone = `${window.innerWidth / 4}px`;
      this.widthShape = `${window.innerWidth / 3.1}px`;
      this.widthDesc = `${window.innerWidth / 2.5}px`;
      this.heightBgRed = `${window.innerHeight / 2.4}px`;
      this.heightBgRedWhy = `${window.innerWidth / 3}px`;
      this.lineHeight = `${window.innerWidth / 50}px`;
      this.paddingShape = `${window.innerWidth / 60}px`;
      this.paddingShapeWhy = `${window.innerWidth / 15}px`;
      this.marginTopTitle = `${window.innerWidth / 100}px`;
      this.heroMargin = `${window.innerWidth / 28}px`;
      this.marginWhy = `${window.innerWidth / 15}px`;
      this.widthNow = window.innerWidth;
      this.shapeMargin = `${window.innerWidth / -15}px`;
      this.fontSize = `${window.innerWidth / 50}px`;
      this.fontSizeTitleHero = `${window.innerWidth / 40}px`;
      this.fontSizePeminjam = `${window.innerWidth / 60}px`;
      this.fontSizePhone = `${window.innerWidth / 50}px`;
      this.fontSizeWhy = `${window.innerWidth / 40}px`;
      this.fontSizeSub = `${window.innerWidth / 70}px`;
      this.fontSizeForm = `${window.innerWidth / 75}px`;
      this.fontSizeTitle = `${window.innerWidth / 60}px`;
      this.fontSizeDescr = `${window.innerWidth / 120}px`;
      this.fontSizeDescription = `${window.innerWidth / 100}px`;
      this.fontSizeBtn = `${window.innerWidth / 80}px`;
      this.fontSizeInside = `${window.innerWidth / 100}px`;
      this.marginTopText = `${window.innerWidth / 8}px`;
      this.marginName = `${window.innerWidth / -230}px`;
      this.marginTopName = `${window.innerWidth / 800}px`;
      this.marginTopDesc = `${window.innerWidth / 6}px`;
      this.descWidth = `${window.innerWidth / 2}px`;
      this.textWidth = `${window.innerWidth / 2}px`;
      this.fontSizeDesc = `${window.innerWidth / 100}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    scrollTo(hash) {
      setTimeout(() => {
        location.href = hash;
      }, 1);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    closeSuccessDialog() {
      this.successPopup = !this.successPopup;
    },
    closeErrDialog() {
      this.errorPopup = !this.errorPopup;
    },
    async submit() {
      this.$refs.form.validate();
      if (this.$route.name === "LPSE") {
        this.form.flag = "LPSE";
      }
      if (this.valid && this.form.gender && this.form.job_type) {
        this.form.phone_number = "0" + this.form.phone_number;
        this.form.amount = Number(this.form.amount);
        const res = await this.$store.dispatch("registerLpse", this.form);
        if (res.data.status === "00") {
          this.successPopup = true;
          this.popupMsg = res.data.message;
          this.$refs.form.reset();
        } else {
          this.errorPopup = true;
          this.popupMsg = res.data.message;
          this.form.phone_number = this.form.phone_number.substring(1);
        }
      } else if (!this.form.gender) {
        this.genderErr = true;
      } else {
        this.jobErr = true;
      }
    },
    async getJobType() {
      let jobs = await this.$store.dispatch("getJobType");
      this.jobTypeOptions = jobs.data.data;
    },
  },
};
</script>
<style scoped>
.Text-Hero {
  width: 763px;
  height: 56px;
  margin: 69px auto 0 auto;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  /* position: absolute; */
}
.Desc-Hero {
  width: 742px;
  height: 48px;
  margin: -40px auto auto;
  font-family: Sora;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: absolute;
}
.Hero {
  width: 100%;
  object-fit: contain;
}
.Why {
  width: 100%;
  min-width: 800px;
}

.arrow {
  z-index: 1;
}
.why-point-1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 50%;
}
.cepat {
  display: flex;
  justify-content: center;
  align-items: center;
}
.why-point-2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 50%;
}
.why-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.why-1 {
  position: relative;
  width: 550px;
}
.why-2 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.why-text {
  background: url("../assets/lpse/Kenapa-1.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-weight: 700;
  font-size: 40px;
}
.what-container {
  padding-right: 100px;
  padding-left: 100px;
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
}
.card1 {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 600px;
  border-radius: 12px;
  padding: 24px;
  background: #f4f7fc;
}

.imgIcon {
  filter: drop-shadow(3px 3px 5px rgb(44 82 182 / 0.3));
}

.card-point1 {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.circle-point {
  position: relative;
  z-index: 2;
  border: 3px solid #2c52b6;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.circle-point1 {
  position: relative;
  z-index: 2;
  border: 3px solid #d3352c;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.one {
  font-weight: 700;
  color: #2c52b6;
  text-align: center;
}
.two {
  font-weight: 700;
  color: #d3352c;
  text-align: center;
}
.point-1 {
  display: flex;
  flex-direction: row;
  text-align: left;
  justify-content: center;
  align-items: center;
  width: 600px;
  border-radius: 12px;
  padding-left: 20px;
  padding-right: 20px;
  background: #ffffff;
  box-shadow: 0px 12px 34px rgba(23, 38, 77, 0.07);
}
.imgCircle {
  background: url("../assets/pengajuan/Base.svg");
  background-position: center;
  background-size: contain;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
}

.text-point {
  padding: 15px;
}

.peminjam {
  font-weight: 700;
  font-size: 24px;
  color: #2c52b6;
}
.dompetKilat {
  font-weight: 700;
  font-size: 24px;
  color: #d3352c;
}
.card2 {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 600px;
  border-radius: 12px;
  padding: 24px;
  background: #faf6f6;
}
.card-title-1 {
  width: 100%;
  position: relative;
  text-align: center;
  color: #2c52b6;
  font-weight: 700;
  font-size: 24px;
}
.card-title-2 {
  width: 100%;
  position: relative;
  text-align: center;
  color: #d3352c;
  font-weight: 700;
  font-size: 24px;
}
.HeroContainer {
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  position: absolute;
}
.HeroContent {
  width: 100%;
  display: flex;
}

.titleText {
  font-stretch: normal;
  font-style: normal;
  color: #252525;
}
.phoneContainer {
  height: 300px;
}
.contentPhone {
  height: 300px;
  flex-grow: 0;
  font-family: Inter;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: white;
}
.Shape {
  /* max-width: 895px; */
  border-radius: 8px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  position: relative;
}
.title-1 {
  flex-grow: 0;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  margin-bottom: 4px;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.desc {
  font-size: 16px;
  text-align: center;
}
.Name-Title {
  flex-grow: 0;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Shape-Button-Text {
  flex-grow: 0;
  font-family: Inter;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  border-radius: 12px;
}

.select {
  overflow: hidden;
}
.input-field {
  flex-grow: 0;
  padding-top: 0px;
  margin: 0px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.float {
  position: fixed;
  bottom: 80px;
  right: -50px;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 100;
}
.my-float {
  width: 80px;
  height: 80px;
}
@media screen and (max-width: 1700px) {
  .Why {
    width: 100%;
    min-width: 400px;
    padding: 70px;
    object-fit: contain;
  }
  /* .Shape {
      max-width: 895px;
      margin: -90px auto 0px auto;
      border-radius: 8px;
      box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
      background-color: #ffffff;
      position: relative;
    } */
}
@media screen and (max-width: 1350px) {
  .phoneContainer {
    height: 620px;
  }
  .contentPhone {
    margin-bottom: 120px;
    height: 300px;
    flex-grow: 0;
    font-family: Inter;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    color: white;
  }
  /* .Shape {
      max-width: 895px;
      margin: -100px auto 0px auto;
      border-radius: 8px;
      box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
      background-color: #ffffff;
      position: relative;
    } */
}
@media screen and (max-width: 1300px) {
  .Why {
    width: 100%;
    min-width: 400px;
    object-fit: contain;
  }
  /* .Shape {
      max-width: 600px;
      max-height: 800px;
      margin: -80px auto 0px auto;
      border-radius: 8px;
      box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
      background-color: #ffffff;
      position: relative;
    } */
}
</style>
